import { SetFromPlace } from '../../types';

export interface Stop {
  label: string;
  city: string;
  state: string;
  placeId?: string;
  address?: SetFromPlace;
}

export const travelForMap = {
  'Outstation One-way': 'One-way trip plan',
  'Outstation Round-trip': 'Round trip plan'
};

export const isInvalidMultiStopForDesktop = (stops: Stop[]) => {
  return !stops?.some(
    stop => stop?.address !== undefined && stop?.address !== null
  );
};

export const isInvalidMultiStopForMobile = (stops: Stop[]) => {
  return !stops?.some(
    stop =>
      stop?.placeId !== undefined &&
      stop?.placeId !== null &&
      stop?.placeId !== ''
  );
};

export const countStopsWithAddress = (stops: Stop[]) => {
  return stops?.filter(
    stop => stop?.address !== undefined && stop?.address !== null
  )?.length;
};

export const formatCity = (city: string, limit: number) => {
  return city?.length > limit ? `${city?.substring(0, limit)}...` : city;
};

export const returnStopText = (stops: Stop[]) => {
  const stop = stops?.find(
    stop => stop?.address !== undefined && stop?.address !== null
  );
  const stopCount = countStopsWithAddress(stops);
  const formattedCity =
    stopCount > 1 ? formatCity(stop?.city || '', 8) : stop?.city;
  return stop
    ? `${formattedCity}  ${stopCount > 1 ? ` +${stopCount - 1}` : ''}`
    : '+ ADD STOPS';
};

export const calculateDaysForMulticity = (date1: Date, date2: Date) => {
  const day1 = date1.getDate();
  const day2 = date2.getDate();
  return day2 - day1;
};
